module.exports = __webpack_public_path__ + "static/media/kerry.169fc434.png";